import RetiredPrimary from './RetiredPrimary';
import RetiredSecondary from './RetiredSecondary';

import { EmploymentClassType } from '../../PrimaryEmployment/types';

export interface PrimaryRetiredProps {
  type: Extract<EmploymentClassType, 'primary'>;
}

export interface SecondaryRetiredProps {
  type: Extract<EmploymentClassType, 'secondary'>;
  index: number;
  arrayName: string;
}

export type RetiredProps = PrimaryRetiredProps | SecondaryRetiredProps;

const Retired: React.FunctionComponent<RetiredProps> = function (props) {
  const { type } = props;
  if (type === 'secondary') {
    const { index, arrayName } = props;
    return <RetiredSecondary index={index} arrayName={arrayName} />;
  }
  return <RetiredPrimary />;
};

export default Retired;
